<app-spinner [visible]="visibleSpinner"></app-spinner>
<app-mensajes
  [code]="code"
  [titulo]="titulo"
  [detalle]="detalle"
  [sw]="sw"
></app-mensajes>
<div class="p-col-12">
  <div class="p-grid">
    <div class="p-col-12">
      <p-card>
        <div class="p-col-12">
          <button
            pButton
            type="button"
            label="Nueva Solicitud"
            icon="pi pi-plus"
            class="ui-button-info"
            style="float: right"
            (click)="goToPage('/inicio')"
          ></button>
        </div>
        <div class="p-col-8">
          <h3>TRÁMITES PENDIENTES</h3>
        </div>
        <div class="p-col-12">
          <p-table
            #dt
            [value]="tramites"
            [paginator]="true"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando registros del {first} al {last} de un total de {totalRecords} registros"
            [rows]="10"
            [rowsPerPageOptions]="[10, 20, 30]"
            sortField="fecha_recepcion"
            sortOrder="-1"
            [scrollable]="true"
            scrollHeight="{{ scroll }}px"
            [globalFilterFields]="[
              'numero_solicitud',
              'nombre_proceso',
              'id_referencia'
            ]"
          >
            <ng-template pTemplate="caption">
              <div class="table-header">
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input
                    pInputText
                    type="text"
                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                    placeholder="Búsqueda global..."
                    class="p-inputtext-sm"
                  />
                </span>
              </div>
            </ng-template>
            <!-- let-"type" para consumir datos -->
            <ng-template pTemplate="header" let-columns>
              <tr class="d-info-table">
                <th class="fix">
                  Número de solicitd
                  <ng-container *ngIf="visibleSpinner">
                    <p-progressBar
                      mode="indeterminate"
                      [style]="{ height: '3px' }"
                    ></p-progressBar>
                  </ng-container>
                </th>
                <th>
                  Proceso que genera el trámite
                  <ng-container *ngIf="visibleSpinner">
                    <p-progressBar
                      mode="indeterminate"
                      [style]="{ height: '3px' }"
                    ></p-progressBar>
                  </ng-container>
                </th>
                <th>
                  Proceso pendiente
                  <ng-container *ngIf="visibleSpinner">
                    <p-progressBar
                      mode="indeterminate"
                      [style]="{ height: '3px' }"
                    ></p-progressBar>
                  </ng-container>
                </th>
                <th>
                  Registro
                  <ng-container *ngIf="visibleSpinner">
                    <p-progressBar
                      mode="indeterminate"
                      [style]="{ height: '3px' }"
                    ></p-progressBar>
                  </ng-container>
                </th>
              </tr>
            </ng-template>
            <!-- let-"type" para consumir datos -->
            <ng-template pTemplate="body" let-tramite>
              <tr class="d-info-table">
                <th class="fix" style="text-align: center">
                  <button
                    pButton
                    type="button"
                    (click)="
                      getURL(
                        tramite.codigo_proceso,
                        tramite.id_solicitud_subsana
                      )
                    "
                    [icon]="
                      tramite.id_solicitud_subsana
                        ? 'pi pi-pencil'
                        : 'pi pi-plus'
                    "
                    class="p-button-sm p-button-rounded d-button-edit"
                    [pTooltip]="
                      tramite.id_solicitud_subsana
                        ? 'Editar tramite'
                        : 'Crear tramite'
                    "
                  ></button
                  >&nbsp;
                  <button
                    pButton
                    type="button"
                    (click)="
                      historialModal(
                        tramite.id_solicitud,
                        tramite.numero_solicitud
                      )
                    "
                    class="p-button-sm p-button-rounded d-button-second"
                    pTooltip="Historial de la solicitud"
                    [icon]="'pi pi-info-circle'"
                  ></button>
                  <br />
                  {{ tramite.numero_solicitud }}
                </th>
                <td class="normal">{{ tramite.nombre_proceso }}</td>
                <td class="normal">{{ tramite.proceso_dependiente }}</td>
                <td class="normal">{{ tramite.id_referencia }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td>No se encontraron resultados.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-card>
    </div>
  </div>
</div>

<p-dialog [header]="title" [style]="view" [(visible)]="showMe" [modal]="true">
  <app-historial-solicitud
    (visual)="spinner($event)"
    [id]="id"
  ></app-historial-solicitud>
</p-dialog>

<app-tramite-notificaciones
  *ngIf="tp"
  (data)="tramite($event)"
  [load]="load"
  [tmsg]="tmsg"
></app-tramite-notificaciones>
